module.exports = __webpack_public_path__ + "static/media/404@2x.ab49a207.png";